import PropTypes from 'prop-types';
import { defineMessages, useIntl } from 'dibs-react-intl';
import classNames from 'classnames';
import styles from '../../styles/main.scss';
import creditCardUtils from 'creditcardutils';

// components
import Text from '../inputs/Text';

const messages = defineMessages({
    placeholder: {
        id: 'dc.CreditCardForm.CardNumber.placeholder',
        defaultMessage: 'Card Number*',
    },
});

const CardNumber = ({
    value,
    autoFocus = false,
    isBlurred,
    disabled,
    error,
    onBlur = () => {},
    onFocus,
    leftDecorator,
    fullWidth = false,
    onChange,
}) => {
    const intl = useIntl();

    function onChangeHandler(event) {
        // format card number and ensure cursor is in the right spot
        const { selectionStart } = event.target;
        const cardNumber = creditCardUtils.formatCardNumber(event.target.value || '');
        const offset = cardNumber[selectionStart - 1] === ' ' ? 1 : 0;
        const inputNode = event.target;
        onChange({ name: 'creditCardNumber', value: cardNumber }, () => {
            inputNode.setSelectionRange(selectionStart + offset, selectionStart + offset);
        });
    }

    return (
        <Text
            name="creditCardNumber"
            dataTn="billing-creditCardNumber"
            value={value}
            pattern="\d*"
            wrapperClass={classNames(styles.left, {
                [styles.fullWidth]: fullWidth,
            })}
            placeholder={intl.formatMessage(messages.placeholder)}
            autoComplete="cc-number"
            autoFocus={autoFocus}
            isBlurred={isBlurred}
            disabled={disabled}
            error={error}
            onChangeEvent={onChangeHandler}
            onBlur={onBlur}
            onFocus={onFocus}
            leftDecorator={leftDecorator}
            inputMode="numeric"
        />
    );
};

CardNumber.propTypes = {
    value: PropTypes.string.isRequired,
    error: PropTypes.string,
    autoFocus: PropTypes.bool,
    isBlurred: PropTypes.bool,
    disabled: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func,
    leftDecorator: PropTypes.node,
    fullWidth: PropTypes.bool,
};

export default CardNumber;
